export const SAVED_SUCCESSFULLY_MESSAGE = 'Saved successfully'
export const CHANGED_SUCCESSFULLY_MESSAGE = 'Changed successfully'
export const DELETED_SUCCESSFULLY_MESSAGE = 'Deleted successfully'
export const DEFAULT_SERVER_ERROR = 'An error occurred'
